// extracted by mini-css-extract-plugin
export default {"sliderTop":"SliderTop_sliderTop__3w0VZ","leftSlide":"SliderTop_leftSlide__XCwiU","rightSlide":"SliderTop_rightSlide__kMGmF"};